import { Pipe } from '@angular/core';

@Pipe({
  name: 'sum'
})
export class SumPipe  {

  transform(items: any[], field: string): number {

    if (!items || !Array.isArray(items) || !field) {
      return 0;
    }

    return items.reduce((total: number, item: any) => {
      const value = Number(item?.[field]) || 0;
      return total + value;
    }, 0);

  }

}